var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"gw-order-summary"},[_vm._t("top"),_vm._v(" "),_vm._t("bottom")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }